import { DateUtil, isNullOrUndefined } from '@uzurv/rideWss/app/util';
import { AbstractModel } from './abstract-model';
import { autoserializeAs, inheritSerialization } from 'cerialize';
import { App } from './app';
import { ReleasePlatform } from './release-platform';

@inheritSerialization(AbstractModel)
export class Release extends AbstractModel {
  @autoserializeAs(App)
  app: App;

  @autoserializeAs(ReleasePlatform)
  releasePlatform: ReleasePlatform;

  version: string;

  @autoserializeAs(Date)
  releaseDate: Date;

  @autoserializeAs(Date)
  deprecationDate: Date;

  static OnSerialized(instance: Release, json: any): void {
    super.OnSerialized(instance, json);

    if (!isNullOrUndefined(instance.releaseDate)) {
      json.releaseDate = DateUtil.serializeDate(instance.releaseDate);
    }

    if (!isNullOrUndefined(instance.deprecationDate)) {
      json.deprecationDate = DateUtil.serializeDate(instance.deprecationDate);
    }
  }

  static OnDeserialized(instance: Release, json: any): void {
    super.OnDeserialized(instance, json);

    if (!isNullOrUndefined(json['releaseDate'])) {
      instance.releaseDate = DateUtil.deserializeDate(json['releaseDate']);
    }

    if (!isNullOrUndefined(json['deprecationDate'])) {
      instance.deprecationDate = DateUtil.deserializeDate(json['deprecationDate']);
    }
  }
}
